(() => {
  function initializePurchaseBar() {
    const bar = document.querySelector('[data-tjb-purchase-bar]');
    if (!bar || bar.dataset.initialized) return;
    const button = bar.querySelector('[data-tjb-purchase-button]');
    const section = bar.closest('[data-section-type]');
    if (!button || !section) return;
    bar.dataset.initialized = 'true';
    let original;
    const visibility = new IntersectionObserver(entries => {
      const entry = entries.find(item => item.target === original);
      if (entry) bar.hidden = entry.intersectionRatio >= 1;
    }, { threshold: 1, rootMargin: '0px 0px -80px 0px' });
    const synchronize = () => {
      const form = document.getElementById(bar.dataset.formId);
      const current = form?.querySelector('button[type="submit"][data-action="add-to-cart"]')
        || form?.querySelector('button[type="submit"]');
      if (current !== original) {
        visibility.disconnect();
        original = current;
        if (original) visibility.observe(original);
      }
      if (!original) {
        bar.hidden = true;
        return;
      }
      button.disabled = original.disabled;
      const label = original.textContent.trim();
      if (button.textContent !== label) button.textContent = label;
    };
    button.addEventListener('click', event => {
      synchronize();
      if (!original) return;
      event.preventDefault();
      if (!original.disabled) original.click();
    });
    synchronize();
    const changes = new MutationObserver(records => {
      if (records.some(record => !bar.contains(record.target))) synchronize();
    });
    changes.observe(section, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled'] });
  }
  function initializeCollectionIntros() {
    document.querySelectorAll('[data-tjb-collection-intro]').forEach(intro => {
      if (intro.dataset.initialized) return;
      intro.dataset.initialized = 'true';
      const content = intro.querySelector('[data-tjb-intro-content]');
      const summary = intro.querySelector('[data-tjb-intro-summary]');
      const toggle = intro.querySelector('[data-tjb-intro-toggle]');
      const richText = content?.querySelector('.rte');
      if (!richText || !summary || !toggle) return;
      const normalize = text => text.replace(/\s+/g, ' ').trim();
      const fullText = normalize(richText.textContent);
      const opening = normalize(richText.querySelector('p')?.textContent || fullText);
      if (!opening) return;
      let sentence;
      if (typeof Intl.Segmenter === 'function') {
        const segmenter = new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'sentence' });
        sentence = segmenter.segment(opening)[Symbol.iterator]().next().value?.segment.trim();
      }
      sentence ||= opening.match(/^.*?[.!?](?:\s|$)/)?.[0].trim() || opening;
      if (sentence.length > 220) {
        const excerpt = sentence.slice(0, 220);
        sentence = excerpt.slice(0, excerpt.lastIndexOf(' ')) + '…';
      }
      if (fullText === sentence && !richText.querySelector('img,video,iframe,table')) return;
      summary.textContent = sentence;
      let expanded = false;
      const mobile = window.matchMedia('(max-width: 640px)');
      const update = () => {
        intro.toggleAttribute('data-tjb-mobile-intro', mobile.matches);
        summary.hidden = !mobile.matches || expanded;
        content.hidden = mobile.matches && !expanded;
        toggle.hidden = !mobile.matches;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.readLess : toggle.dataset.readMore;
      };
      toggle.addEventListener('click', () => {
        expanded = !expanded;
        update();
      });
      mobile.addEventListener('change', update);
      update();
    });
  }
  function initialize() {
    initializePurchaseBar();
    initializeCollectionIntros();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
